import { get, post } from "./axios";
//首页信息
const get_company = (data) => post("/api/index/get_company_ll", data);
//获取年报资料
const get_company_fill = (data) => post("/api/index/get_company_fill", data);
//提交申报资料
const in_company_fill = (data) => post("/api/index/in_company_fill", data);
//获取openid
const get_openid = (data) => post("/api/index/get_openid", data);
//获取微信内置支付信息
const wx_pay = (data) => post("/api/index/wx_pay", data);
//外置浏览器微信支付链接
const h5_pay = (data) => post("/api/index/h5_pay", data);
//支付宝支付链接
const alipay = (data) => post("/api/index/alipay", data);
//订单
const pay_list = (data) => post("/api/index/pay_list", data);
export { get_company, get_company_fill, in_company_fill, h5_pay, get_openid, wx_pay, alipay, pay_list };
